import React from "react";

export default function PageNotFound() {
  return (
    <div className="p-20 flex flex-col justify-center items-center">
      <img
        className="w-64"
        src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/Oops.svg"
        alt="404"
      />
      <div className="flex space-x-2 text-3xl">
        <h3>Error |</h3>
        <h3>Page Not Found</h3>
      </div>
    </div>
  );
}
